import React from 'react';
import {
    Box,
    Card,
    CardContent,
    Container,
    Grid,
    IconButton,
    Skeleton,
    Typography,
    Button,
} from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';

const LessonSkeleton = () => {
    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            {/* Main Grid Layout - same as your actual page */}
            <Grid container spacing={3}>
                {/* Left Column - Video Player Skeleton */}
                <Grid item xs={12} md={8}>
                    <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={450}
                        sx={{
                            borderRadius: 2,
                            bgcolor: 'grey.300',
                        }}
                    />
                </Grid>

                {/* Right Column - Content */}
                <Grid item xs={12} md={4}>
                    <Card
                        sx={{
                            height: '100%',
                            p: 2,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between', // This will push content to top and bottom
                        }}
                    >
                        {/* Content at the top */}
                        <Box>
                            {/* Title Skeleton */}
                            <Skeleton
                                variant="text"
                                width="80%"
                                height={40}
                                sx={{ mb: 2 }}
                            />

                            {/* Description Skeleton */}
                            <Box sx={{ mb: 3 }}>
                                <Skeleton variant="text" width="100%" />
                                <Skeleton variant="text" width="100%" />
                                <Skeleton variant="text" width="85%" />
                            </Box>
                        </Box>

                        {/* Content at the bottom */}
                        <Box>
                            {/* Navigation Controls */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    mb: 3,
                                }}
                            >
                                <Skeleton
                                    variant="rounded"
                                    width={50}
                                    height={36}
                                />

                                <Skeleton
                                    variant="text"
                                    width="80px"
                                    sx={{ mx: 2 }}
                                />

                                <Skeleton
                                    variant="rounded"
                                    width={50}
                                    height={36}
                                />
                            </Box>

                            {/* Bottom Buttons */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <Skeleton
                                    variant="rounded"
                                    width={100}
                                    height={36}
                                />
                                <Skeleton
                                    variant="rounded"
                                    width={100}
                                    height={36}
                                />
                            </Box>
                        </Box>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    );
};

export default LessonSkeleton;
